import { ExtraHoursRangeFragment } from 'generated/resources/graphql'

class ExtraHoursRangeUtils {
  static isDefault(extraHoursRange: Pick<ExtraHoursRangeFragment, 'default'>) {
    return extraHoursRange.default
  }

  static customExtraHoursRanges<T extends Pick<ExtraHoursRangeFragment, 'default'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.filter((range) => !this.isDefault(range))
  }

  static defaultExtraHoursRanges<T extends Pick<ExtraHoursRangeFragment, 'default'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.find((range) => this.isDefault(range))
  }

  static hasCustomExtraHoursRanges<T extends Pick<ExtraHoursRangeFragment, 'default'>>(
    extraHoursRanges: T[]
  ) {
    return this.customExtraHoursRanges(extraHoursRanges).length > 0
  }

  static hasUnlimitedExtraHourRanges<T extends Pick<ExtraHoursRangeFragment, 'unlimited'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.some((range) => this.isUnlimited(range))
  }

  static hasTimeOffRanges<T extends Pick<ExtraHoursRangeFragment, 'poolType'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.some((range) => this.isTimeOff(range))
  }

  static isTimeOff(extraHoursRange: Pick<ExtraHoursRangeFragment, 'poolType'>) {
    return extraHoursRange.poolType === 'timeoff'
  }

  static isUnlimited(extraHoursRange: Pick<ExtraHoursRangeFragment, 'unlimited'>) {
    return extraHoursRange.unlimited
  }

  static sortedCustomByFromMinute<
    T extends Pick<ExtraHoursRangeFragment, 'default' | 'fromMinute'>,
  >(extraHoursRanges: T[]) {
    return this.customExtraHoursRanges(extraHoursRanges).sort((a, b) => a.fromMinute - b.fromMinute)
  }
}

export default ExtraHoursRangeUtils
